import c from 'classnames';
import { IconActivity } from 'featherico';
import meeting from '../../../../../img/icons/moduleIcons/1_1_meeting.svg';
import icon360 from '../../../../../img/icons/moduleIcons/360.svg';
import feedbackRequest from '../../../../../img/icons/moduleIcons/feedback_request.svg';
import giveFeedback from '../../../../../img/icons/moduleIcons/give_feedback.svg';
import privateNote from '../../../../../img/icons/moduleIcons/new_private_note.svg';
import Badge from '../../../features/Praise/components/Badge';
import styles from './styles.m.less';

export const MeetingIcon = () => <img src={meeting} alt="" />;
export const FeedbackCycleIcon = () => <img src={icon360} alt="" />;
export const FeedbackRequestIcon = () => <img src={feedbackRequest} alt="" />;
export const FeedbackSingleIcon = () => <img src={giveFeedback} alt="" />;
export const PrivateNoteIcon = () => <img src={privateNote} alt="" />;
export const ObjectiveIcon = ({ objective }) => (
    <div className={c('svg-icon-' + objective.icon, styles.objectiveIcon)} />
);
export const SurveyIcon = () => (
    <div className={styles.surveyIconWrapper}>
        <IconActivity />
    </div>
);

export const PraiseBadgeIcon = ({ praise }) => <Badge size={'60px'} badge={praise.badge} />;
